/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ContractUsageResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetContractUsageRequestParams {
    usageYear: string;
    contractId: string;
}

export class ClsGetContractUsageRequestParams {
    usageYear: string = undefined;
    contractId: string = undefined;
}


export interface AdminArchivingUsageApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Export archiving usage data per contractId.
     * This function will export archiving usage data for a customer by a given contract identifier. The object contains information how many ERSes are billable in total and how many ERSes were activated by each month. 
* @param requestParameters
     */
    getContractUsage(requestParameters: GetContractUsageRequestParams, extraHttpRequestParams?: any): Observable<ContractUsageResponseDTO>;

}
